/**
 * Copyright 2023-2024 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ExecutionPolicy, SkipWindowType } from "~/generated/graphql";
import { ScheduleType } from "~/views/plans/types";
import { FormData } from "./formConfig";
import { FormField, TimeUnits } from "./types";

export const maxInAdvance = 2147483647;
export const defaultWindowDuration = "60";

export enum PlanField {
  DETAILS = "details",
  SCHEDULE_PLAN = "schedule_plan",
  SCHEDULE_TYPE = "schedule_type",
  PLAN_SETTINGS = "plan_settings",
  GENERAL_NOTIFICATIONS = "general_notifications",
  ERRORS = "plan_errors",
  PLAN_STATUS = "plan_status",
}

export enum PlanErrors {
  PLAN_ACTION_NAMES = "action names",
  PLAN_NOTIFICATION_GROUPS = "action notifications",
  PLAN_ACTION_SETTINGS = "action settings",
}

export type PlanData = {
  [PlanField.DETAILS]: FormData | undefined;
  [PlanField.SCHEDULE_PLAN]: FormData | undefined;
  [PlanField.SCHEDULE_TYPE]: ScheduleType | undefined;
  [PlanField.PLAN_SETTINGS]: FormData | undefined;
  [PlanField.GENERAL_NOTIFICATIONS]: FormData | undefined;
  [PlanField.PLAN_STATUS]: { planEnabled: boolean } | undefined;
  [PlanField.ERRORS]?: PlanErrors[] | [];
};

export type PlanScheduleData = {
  [PlanField.SCHEDULE_PLAN]: FormData | undefined;
  [PlanField.SCHEDULE_TYPE]: ScheduleType | undefined;
};

export const defaultValues: PlanData = {
  [PlanField.DETAILS]: undefined,
  [PlanField.SCHEDULE_PLAN]: undefined,
  [PlanField.SCHEDULE_TYPE]: ScheduleType.recurring,
  [PlanField.PLAN_SETTINGS]: undefined,
  [PlanField.GENERAL_NOTIFICATIONS]: undefined,
  [PlanField.PLAN_STATUS]: { planEnabled: true },
  [PlanField.ERRORS]: [],
};

export const defaultActionSettingsValues = {
  [FormField.UNIT]: TimeUnits.minutes,
  [FormField.EXECUTION_POLICY]: ExecutionPolicy.Anyway,
  [FormField.RUN_IN_SEQUENCE]: false,
  [FormField.SKIP_WINDOW]: SkipWindowType.Never,
  [FormField.WINDOW_DURATION]: defaultWindowDuration,
  [FormField.INPUT_PARAMETERS]: [],
};

export const defaultBatchSettingsValues = {
  [FormField.EXECUTION_POLICY]: ExecutionPolicy.Anyway,
  [FormField.SKIP_WINDOW]: SkipWindowType.Never,
  [FormField.WINDOW_DURATION]: defaultWindowDuration,
  [FormField.UNIT]: TimeUnits.minutes,
  [FormField.RUN_IN_SEQUENCE]: false,
};

export enum SystemActionNames {
  DELAY = "DELAY",
}
